module.exports = __webpack_public_path__ + "img/s1_t2_03.f761f699.jpeg";